import { useState } from 'react';
import { Box, Divider } from '@nimbus-ds/components';
import { useAgentChatPanelContext } from 'App/components/AgentChatPanelContext';
import {
  ChatHeader,
  ChatWelcomeScreen,
  ChatMessagesContainer,
  AgentChatInput,
} from '..';
import { useAgentChatContext } from '../../contexts';

function AgentChatView(): JSX.Element {
  const { closeAgent } = useAgentChatPanelContext();
  const [externalInputValue, setExternalInputValue] = useState<string>('');
  const { isConversationEmpty } = useAgentChatContext();

  const handleQuickAction = (action: string) => {
    if (!action.trim()) return;
    setExternalInputValue(action);
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      backgroundColor="neutral-background"
      height="100%"
      borderRadius="3"
      borderStyle="solid"
      borderColor="neutral-surfaceHighlight"
      borderWidth="1"
      // Avoid outside modal dismissing when interacting with the chat
      data-nimbus-outside-press-ignore
    >
      <ChatHeader onClose={closeAgent} />
      <Divider />

      <Box
        display="flex"
        flexDirection="column"
        flex="1"
        backgroundColor="neutral-background"
        overflow="auto"
      >
        {isConversationEmpty ? (
          <ChatWelcomeScreen onQuickAction={handleQuickAction} />
        ) : (
          <ChatMessagesContainer />
        )}
      </Box>

      <Divider />
      <AgentChatInput
        externalInputValue={externalInputValue}
        setExternalInputValue={setExternalInputValue}
      />
    </Box>
  );
}

export default AgentChatView;
